import React, {useEffect, useState} from "react";
import {Form, Card, Collapse, Tag, Button} from "antd";
import {CisUI} from "../../../../util/CISUI";
import Config from "../../../../util/config";
import jsonfile from "./migration.json";
import AdvancedSearch from "../../../../util/AdvancedSearch";
import ActionButton from "../../../../util/actionbutton";
import IntlMessages from "util/IntlMessages";
import SmartDataTable from 'react-smart-data-table';
import {Link, useHistory} from "react-router-dom";
import axiosinstance from "../../../../util/Api";
import CircularProgress from "../../../../components/CircularProgress";
import moment from "moment";

const Panel = Collapse.Panel;

const MigrationHistory = () => {
    const [loader, setLoader] = useState(false);
    const [apiData, setAPIData] = useState([]);
    const [totalData, setTotalData] = useState(0);
    const [form] = Form.useForm();
    const history = useHistory();
    const [state,setState] = useState({
        reqURL: Config.apiserver+jsonfile.urls.list,
        filtervalue : '',
        subtitle: ''
    });

    const getData = () => {
        setLoader(true)
        axiosinstance.get(state.reqURL)
            .then(res => {
                console.log(res.data.data.length)
                if(res.data.status === 1){
                    setAPIData(res.data.data);
                    setTotalData(res.data.data.length);
                }
                setLoader(false)
            })
            .catch(error => {
                setLoader(false)
                console.log(error)
            })
    }

    useEffect(() => {
        getData()
    }, [state.reqURL])

    const headers = {
        id: {
            text: <IntlMessages id="ID"/>,
            sortable: true,
            filterable: true,
            transform: (value, id, row) => ++id
        },
        area: {
            text: <IntlMessages id="Level"/>,
            sortable: true,
            filterable: true,
            transform: (value, idx, row) => (
                <Link to={"migrationrequestdetails/"+row.id}>{value}</Link>
            )
        },
        region: {
            text: <IntlMessages id="Area"/>,
            sortable: true,
            filterable: true
        },
        district: {
            text: <IntlMessages id="District"/>,
            sortable: true,
            filterable: true,
        },
        local: {
            text: <IntlMessages id="Local"/>,
            sortable: true,
            filterable: true,
        },
        effective_date: {
            text: <IntlMessages id="Efective Date"/>,
            sortable: true,
            filterable: true,
            transform: (value, id, row) => moment(value).format('MM/DD/YYYY')
        },
        destination_region: {
            text: <IntlMessages id="Destination Area"/>,
            sortable: true,
            filterable: true,
        },
        destination_district: {
            text: <IntlMessages id="Destination District"/>,
            sortable: true,
            filterable: true,
        },
        status: {
            text: <IntlMessages id="Status"/>,
            sortable: true,
            filterable: true,
            transform: (value, id, row) => {
                let status = "";
                if(value === 0) {
                    status =  <Tag color="#8b8b8b">Pending</Tag>
                }
                else if(value === 1) {
                    status = <Tag color="#34495e">Approved</Tag>
                }
                else if(value === 3) {
                    status = <Tag color="#f5222d">Rejected</Tag>
                }
                // if(value === 1){
                //     status = <IntlMessages id="Approved"/>;
                // }
                // else if(value === 0){
                //     status = <IntlMessages id="Pending"/>;
                // }
                // else if(value === 2){
                //     status = <IntlMessages id="Rejected"/>;
                // }
                return status;
            }
        },
        created_by: {
            text: <IntlMessages id="Created By"/>,
            sortable: true,
            filterable: true,
        },
        created_at: {
            text: <IntlMessages id="Created At"/>,
            sortable: true,
            filterable: true,
            transform: (value, id, row) => moment(value).format('MM/DD/YYYY HH:mm:ss')
        },
        // approved: {
        //     text: <IntlMessages id="Approved"/>,
        //     sortable: true,
        //     filterable: true,
        //     transform: (value, index, row) => {
        //         if(row.status == )
        //     }
        // },
        actions: {
            text: <IntlMessages id="Actions" />,
            sortable: false,
            filterable: false,
            transform: (value, idx, row) => (
                <>
                    {ActionButton(row.id,jsonfile.urls, "", "", 1, [{'url': '', 'hasID': 1, 'label': 'Approve'}])}
                    {
                        row.status === 0 &&
                        <Link to={"migrationrequestdetails/"+row.id} style={{ border: "1px solid #072f4c",
                            padding: "2px 5px",
                            borderRadius: "3px",
                            background: "#072f4c", color: "#fff"}}>
                            {/*<button className="btn btn-sm btn-primary">*/}
                                {/*<i className="fas fa-pencil-alt"/>*/}
                                Approve
                            {/*</button>*/}
                        </Link>
                    }

                </>
            ),
        },
    };

    const orderedHeaders = jsonfile.listView.title;


    const onFinish = values => {
        //console.log('Received values of form: ', values);
        const qsup = CisUI().getQueryStrings(values);
        history.push("?"+qsup);
        const newURL = Config.apiserver+jsonfile.urls.list+"/?"+qsup;
        console.log(newURL);
        setState({reqURL: newURL});
    };

    let filterValue = "";

    // const handleOnFilter = ({ target: { name, value } }) => {
    //     //filterValue = value;
    //     console.log("filteringwith :"+ value);
    // }


    let  searchView = "";
    if(jsonfile.has_search) {
        searchView = <Card className="advance-search-card">
            <Collapse
                accordion
                expandIconPosition="right"
                defaultActiveKey={['1']} >
                <Panel header={<IntlMessages id="Advance Search" />}  key="1">
                    <Form
                        key={5}
                        form={form}
                        {...CisUI().formItemLayout}
                        name="advanced_search"
                        className="ant-advanced-search-form"
                        onFinish={onFinish}
                    >
                        {AdvancedSearch(jsonfile.inputSearch)}
                    </Form>
                </Panel>
            </Collapse>
        </Card>
    }

    const getExtra = (
        <>
            {/*<Search*/}
            {/*    placeholder='Filter...'*/}
            {/*    name='filtervalue'*/}
            {/*    onSearch={handleOnFilter}*/}
            {/*    onChange={handleOnFilter}*/}
            {/*    style={{width: 200}}*/}
            {/*/>*/}
            {/*{CisUI().listAction("../"+jsonfile.urls.add, "", state.reqURL, "data", 'company_info', jsonfile, state.subtitle, "landscape")}*/}
            {CisUI().ListActionButtonV2("../"+jsonfile.urls.add,"",state.reqURL,jsonfile, totalData, 'departments', 'All Department')}
        </>
    );

    if(loader){
        return <CircularProgress />;
    }

    return (

        <>
            {searchView}
            <Card title={<IntlMessages id={jsonfile.listtitle} />} extra={getExtra}>
                <SmartDataTable
                    name='test-fake-table'
                    data={apiData}
                    dataRequestOptions={CisUI().HeaderRequest}
                    dataKey="data"
                    headers={headers}
                    orderedHeaders={orderedHeaders}
                    hideUnordered={CisUI().hideUnordered}
                    className={CisUI().sematicUI.table}
                    filterValue={filterValue}
                    perPage={CisUI().perPage}
                    sortable
                    withLinks
                    dynamic
                    withHeader
                    loader={CisUI().loader}
                    parseBool={{
                        yesWord: 'Yes',
                        noWord: 'No',
                    }}
                    parseImg={{
                        style: {
                            border: '1px solid #ddd',
                            borderRadius: '50px',
                            padding: '3px',
                            width: '30px',
                            height: '30px'
                        },
                    }}
                    emptyTable={CisUI().emptyTable}
                />
            </Card>
        </>
    );
};

export default MigrationHistory;